import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertEmpJobwork = createAsyncThunk('insertEmpJobwork', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=inserJobworkPayment`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertAdvanceAmt = createAsyncThunk('insertAdvanceAmt', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertAdvancePayment`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchJobworkPayment = createAsyncThunk('fetchJobworkPayment', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=getJobworkpayment`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchJobworkMemo = createAsyncThunk('fetchJobworkMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getJobworkMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchDeptEmpJobwork = createAsyncThunk('fetchDeptEmpJobwork', async (id) => {
    try {
        // const endpoint = id ? `getKajeEmplist&empId=${id}` : 'getKajeEmplist';
        const response = await axios.get(`${baseUrl}?apicall=getDepartEmp_jobwork&departId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchJobworkPaymentData = createAsyncThunk('fetchJobworkPaymentData', async (id) => {

    try {
        const endpoint = id ? `getJobworkPaymentdata&jobpId=${id}` : 'getJobworkPaymentdata';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAdvancePayment = createAsyncThunk('fetchAdvancePayment', async () => {
    try {
        // const endpoint = id ? `getKajeRegister&kId=${id}` : 'getKajeRegister';
        const endpoint = 'getAdvancePaymentdata';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteAmountPaytype = createAsyncThunk('deleteAmountPaytype', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteAdvancePayment&advId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteJobworkPay = createAsyncThunk('deleteJobworkPay', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteJobworkCalculation&jobId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const jobworkApiSlice = createSlice({
    name: 'jobworkDatalist',
    initialState: {
        isLoading: false,
        jobMemo: null,
        deptEmp: null,
        jobdata: null,
        jobpay: null,
        advamt: null,
        delamt: null,
        deljob: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchJobworkMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchJobworkMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.jobMemo = action.payload;
        });
        builder.addCase(fetchJobworkMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchDeptEmpJobwork.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchDeptEmpJobwork.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deptEmp = action.payload;
        });
        builder.addCase(fetchDeptEmpJobwork.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchJobworkPaymentData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchJobworkPaymentData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.jobdata = action.payload;
        });
        builder.addCase(fetchJobworkPaymentData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchJobworkPayment.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchJobworkPayment.fulfilled, (state, action) => {
            state.isLoading = false;
            state.jobpay = action.payload;
        });
        builder.addCase(fetchJobworkPayment.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchAdvancePayment.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAdvancePayment.fulfilled, (state, action) => {
            state.isLoading = false;
            state.advamt = action.payload;
        });
        builder.addCase(fetchAdvancePayment.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteAmountPaytype.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteAmountPaytype.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delamt = action.payload;
        });
        builder.addCase(deleteAmountPaytype.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteJobworkPay.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteJobworkPay.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deljob = action.payload;
        });
        builder.addCase(deleteJobworkPay.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default jobworkApiSlice.reducer;
